import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Branches from "../components/site/Branches";
import Facilities from "../components/site/Facilities";
import Fees from "../components/site/Fees";
import Gallery from "../components/site/Gallery";
import WhyChoose from "../components/site/WhyChoose";
import Reviews from "../components/site/Reviews";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingWhatsApp from "../components/site/FloatingWhatsApp";
import SchemaMarkup from "../components/site/SchemaMarkup";
import { Toaster } from "../components/ui/sonner";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#0F0F0F] text-white pb-14 md:pb-0">
      <SchemaMarkup />
      <Header />
      <main>
        <Hero />
        <Branches />
        <Facilities />
        <Fees />
        <Gallery />
        <Reviews />
        <WhyChoose />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}
